'use strict';

module.exports = blockquote;

var wrap = require('../wrap');
var all = require('../all');

/* Transform a block quote. */
function blockquote(h, node) {
  return h(node, 'blockquote', wrap(all(h, node), true));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/blockquote.js
// module id = 959
// module chunks = 0